// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f0YSH","label":"styles_label__2MeGP"};